var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgChatIconSv(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    className: "icon chat-icon",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 0c6.627 0 12 5.373 12 12 0 2.501-.765 4.824-2.074 6.746l2.015 4.229a.749.749 0 01-.829 1.013l-5.86-1.195A11.967 11.967 0 0112 24C5.373 24 0 18.627 0 12S5.373 0 12 0zM6.6 10.5a1.5 1.5 0 10.001 3.001A1.5 1.5 0 006.6 10.5zm10.8 0a1.5 1.5 0 10.001 3.001A1.5 1.5 0 0017.4 10.5zm-5.4 0a1.5 1.5 0 10.001 3.001A1.5 1.5 0 0012 10.5z"
  })));
}

export default SvgChatIconSv;